import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OUTCOMES } from "../../../constants";
import { FlowScreenWrapper } from "./FlowScreenWrapper";
import { SingleTextForm } from "./SingleTextForm";
import { useAuthContext } from "../../../AuthContextWrapper";
import { CONSTANTS } from "@theatticusapp/atticus-shared-components";

interface Props {
  title?: string;
  screenData?: any;
}

export const PhoneScreen = ({ screenData, title }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow } = useAuthContext()
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const phoneWrapper = screenData?.length && screenData[0];
  const phone = (phoneWrapper?.phone as string) || "";

  const handleComplete = async (name: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // TODO: replace "me" with businesses identifier needed to save data
    if (
      !(await flow?.saveData(currentScreen, "me", {
        name: name,
      }))
    ) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title={title}>
      <SingleTextForm
        initText={phone}
        inputMatches={{
          regexp: CONSTANTS.REGEX.phone,
          failMessage: "Phone number is not valid",
        }}
        textLabel="Phone number"
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
